import { SERVICE_HAPPY_ORDER_UPDATE } from '../mutationTypes';

const initState = {
  orders: [],
};
const getters = {};
const state = {
  ...JSON.parse(JSON.stringify(initState)),
};

const mutations = {
  [SERVICE_HAPPY_ORDER_UPDATE](states, newValue = initState.orders) {
    const orders = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, { orders });
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
